export default __webpack_public_path__ + "static/media/flag-venezuela.5581cfb4.svg";